import { Link as RouterLink } from "react-router";
import styled, { css } from "styled-components";

export const LinkStyles = css`
  color: ${({ theme }) => `${theme.colors.blueDark}`};
  font-weight: 500;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const Link = styled(RouterLink)`
  ${LinkStyles}
`;

export const TopScoreLink = styled(RouterLink)`
  ${LinkStyles}
  color: ${({ theme }) => `${theme.colors.white}`};
  text-decoration: underline;
`;

export default Link;
